import { render, staticRenderFns } from "./ObjectCardSimplified.vue?vue&type=template&id=1ab4f992&scoped=true&"
import script from "./ObjectCardSimplified.vue?vue&type=script&lang=js&"
export * from "./ObjectCardSimplified.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardSimplified.vue?vue&type=style&index=0&id=1ab4f992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab4f992",
  null
  
)

export default component.exports